module.exports = "data:image/png;base64,R0lGODdhAQABAIAAAAAAAAAAACH5BAEAAAAALAAAAAABAAEAAAgFAAEsCAgAOw=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/blank.png
// module id = 580
// module chunks = 4